import styled from 'styled-components';
import { Drawer, Collapse, Tag } from 'antd';

export const StyledDrawer = styled(Drawer)`
  .ant-drawer-wrapper-body {
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
  button {
    width: auto;
    &:hover { color: #4080E2; }
  }
  .anticon-close{
    width: 20px;
  }
  .ant-drawer-header-title {
    flex-direction: row-reverse;
  }
  .ant-drawer-body {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    padding: 0px;
    .ant-collapse-borderless {
      background-color: white;
      .ant-list-footer {
        background-color: white;
      }
    }
  }
  .ant-drawer-close{
    right: -8px;
    position: relative;
  }
  .ant-drawer-header {
    padding: 16px;
  }
`;

export const SectionWrapper =  styled.div`
  position:relative;
  min-height:200px;
  flex: 1;
`;

export const StyledMoreDrawer = styled(StyledDrawer)`
  .ant-drawer-body {
    padding: 16px;
  }
`;

export const DrawerHeader = styled.div`
  display: flex;
  justify-content: start;
  align-items: flex-end;
`;

export const SettingsBtn =  styled.div`
  cursor: pointer;
  line-height: 1.25;
  &:hover {
    svg {
      path, circle {
        stroke: #4080E2;
      }
    }
  }
`

export const HelpLink =  styled.a`
  cursor: pointer;
  line-height: 1;
  vertical-align: middle;
  &:hover {
    svg {
      rect {
        stroke: #4080E2;
      }
      path {
        fill: #4080E2;
      }
    }
  }
`

export const StyledCollapse = styled(Collapse)`
  div:nth-of-type(3) {
    margin-right: 3px;
  }
`;

export const ComingSoonText = styled.div`
  font-style: italic;
`;

export const StyledTag = styled(Tag)`
  transform: scale(0.9);
`;

export const FlexFill = styled.div`
  display: flex;
  flex: 1;
`;

export const ReleaseTag = styled.div`
  font-size: 12px;
  color: rgb(134, 134, 134);
`;
